import { Box, Switch, SwitchProps, Typography } from "@mui/material"

interface IProps extends SwitchProps {
    leftLabel?: string
    rightLabel?: string
}

export const KaziSwitch = ({ leftLabel, rightLabel, ...props}:IProps) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Box
            display={'flex'}
            flexDirection={'row'}
            alignItems={'center'}
        >
            {/* @ts-ignore */}
            {leftLabel && <Typography fontSize={props?.sx?.fontSize}>{leftLabel}</Typography>}
            <Switch  {...props}/>
            {/* @ts-ignore */}
            {rightLabel && <Typography fontSize={props?.sx?.fontSize}>{rightLabel}</Typography>}
        </Box>
    )
}